import { toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter d-flex flex-row justify-content-between align-items-center" }
const _hoisted_2 = { class: "filter__box d-flex justify-content-start align-items-center" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "name"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationTag = _resolveComponent("NotificationTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        for: _ctx.text,
        class: "filter__label justify-self-start d-flex flex-row align-items-center"
      }, [
        _createTextVNode(_toDisplayString(_ctx.text), 1),
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: _ctx.text,
          name: _ctx.text,
          class: "filter__checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isClicked) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('filterToggled', _ctx.isClicked)))
        }, null, 40, _hoisted_4), [
          [_vModelCheckbox, _ctx.isClicked]
        ]),
        _hoisted_5
      ], 8, _hoisted_3)
    ]),
    (_ctx.showNumber)
      ? (_openBlock(), _createBlock(_component_NotificationTag, {
          key: 0,
          extraClass: "number",
          value: _ctx.countComputed?.toString(),
          colorType: _ctx.colourClass
        }, null, 8, ["value", "colorType"]))
      : _createCommentVNode("", true)
  ]))
}